import { useLocStrings } from '@office-start/loc-service';
import React from 'react';
import styles from './SkipToMainComponent.module.scss';
// SkipToMainComponent is a component that renders a link that allows users to skip to the main content of the page.
// This is a11y requirement so users can skip entire shell and get
// to the "main content" (i.e page that is not shell header or appbar)
// Component is added as the very first element on the page and sets up an element with opacity:0
// so it is not visible on the page to regular users
// When user tabs to the link, it becomes visible (via CSS's :focus selector) and then user can click on it to skip
// to the main content.
export var SkipToMainComponent = function (_a) {
    var mainContentElementId = _a.mainContentElementId;
    var locStrings = useLocStrings().data;
    var skipToMainContentLabel = locStrings === null || locStrings === void 0 ? void 0 : locStrings.a11yResources.skipToMainContent;
    return (React.createElement("a", { className: styles.skipToMainContentLink, href: "#".concat(mainContentElementId), title: skipToMainContentLabel, target: "_self", "aria-label": skipToMainContentLabel }, locStrings === null || locStrings === void 0 ? void 0 : locStrings.a11yResources.skipToMainContent));
};
//# sourceMappingURL=SkipToMainComponent.js.map